module.exports = "<ng4-loading-spinner [timeout]=\"120000\"> </ng4-loading-spinner>\r\n<router-outlet>\r\n    <app-spinner></app-spinner>\r\n</router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main